<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ (dialogData ? 'AddUserTab.EditAccount' : 'UserManagement.InviteUser') | translate }}</h2>
      <p class="subtitle">{{ (dialogData ? 'UserManagement.DialogEditSubtitle' : 'UserManagement.DialogInviteSubtitle') | translate }}</p>
    </div>
    @if (dialogRef) {
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <mat-dialog-content class="form-content">
    @if (userForm) {
      <form [formGroup]="userForm">
        @if (dialogData) {
          <div class="w-100 mb-3">
            <mat-label class="form-label mb-1">{{ 'ManageUser.FirstName' | translate }}</mat-label>
            <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
              <input matInput [placeholder]="'UserManagement.FirstNamePlaceholder' | translate" formControlName="firstName" />
            </mat-form-field>
          </div>

          <div class="w-100 mb-3">
            <mat-label class="form-label mb-1">{{ 'ManageUser.LastName' | translate }}</mat-label>
            <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
              <input matInput [placeholder]="'UserManagement.LastNamePlaceholder' | translate" formControlName="lastName" />
            </mat-form-field>
          </div>

          <div class="w-100 mb-3">
            <mat-label class="form-label mb-1">{{ 'ManageUser.Email' | translate }}</mat-label>
            <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
              <input matInput type="email" [placeholder]="'UserManagement.EmailPlaceholder' | translate" formControlName="email" />
            </mat-form-field>
          </div>
        } @else {
          <div class="invite-mode-container">
            <div class="segmented-control">
              <button type="button" class="segment-btn" [class.active]="inviteMode() === 'single'" (click)="inviteMode.set('single')">
                {{ 'UserManagement.SingleInvite' | translate }}
              </button>
              <button type="button" class="segment-btn" [class.active]="inviteMode() === 'bulk'" (click)="inviteMode.set('bulk')">
                {{ 'UserManagement.BulkInvite' | translate }}
              </button>
            </div>
          </div>

          @if (inviteMode() === 'single') {
            <div class="w-100 mb-3">
              <mat-label class="form-label mb-1">{{ 'ManageUser.Email' | translate }}</mat-label>
              <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
                <input matInput type="email" [placeholder]="'UserManagement.EmailPlaceholder' | translate" formControlName="email" />
              </mat-form-field>
            </div>
          } @else {
            <div class="csv-help-banner">
              <div class="help-header">
                <div class="help-title">
                  <mat-icon>info</mat-icon>
                  {{ 'UserManagement.CsvInstructionsTitle' | translate }}
                </div>
                <button type="button" class="template-download-btn" (click)="downloadTemplate()">
                  <mat-icon>download</mat-icon>
                  {{ 'UserManagement.DownloadTemplate' | translate }}
                </button>
              </div>
              <p class="help-text">
                {{ 'UserManagement.CsvInstructionsBody' | translate }}
              </p>
            </div>

            <div class="w-100 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <mat-label class="form-label mb-0">{{ 'UserManagement.BulkEmailsLabel' | translate }}</mat-label>
                @if (parsedEmails().length > 0) {
                  <mat-chip>{{ parsedEmails().length }} {{ 'UserManagement.ValidEmailsCount' | translate }}</mat-chip>
                }
              </div>
              <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
                <textarea
                  matInput
                  rows="4"
                  [placeholder]="'UserManagement.BulkEmailsPlaceholder' | translate"
                  [value]="bulkRawInput()"
                  (input)="bulkRawInput.set($any($event.target).value)"
                ></textarea>
              </mat-form-field>

              @if (csvErrors().length > 0) {
                <div class="csv-validation-box">
                  <div class="box-title">{{ 'UserManagement.CsvValidationErrorsTitle' | translate }} ({{ csvErrors().length }})</div>
                  <ul class="error-list">
                    @for (err of csvErrors(); track err.line) {
                      <li>
                        <strong>Line {{ err.line }}:</strong>
                        {{ err.message }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }

          <div class="w-100 mb-3">
            <mat-label class="form-label mb-1">{{ 'UserManagement.Role' | translate }}</mat-label>
            <ui-select formControlName="role" [options]="roleOptions" [placeholder]="'UserManagement.Role' | translate" />
          </div>

          <div class="w-100 mb-3">
            <mat-label class="form-label mb-1">{{ 'UserManagement.AssignToGroup' | translate }}</mat-label>
            <ui-select formControlName="groupId" [options]="groupOptions()" [placeholder]="'UserManagement.AssignToGroup' | translate" />
          </div>
        }
      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-actions">
      @if (inviteMode() === 'bulk') {
        <button mat-flat-button btnType="ghost" (click)="fileInput.click()">
          <mat-icon>upload_file</mat-icon>
          {{ 'UserManagement.UploadCSV' | translate }}
        </button>
        <input #fileInput type="file" accept=".csv,.txt" (change)="onFileSelected($event)" style="display: none" />
      }
    </div>

    <div class="right-actions">
      <button mat-flat-button btnType="neutral" (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button btnType="action" [disabled]="userForm?.invalid" (click)="dialogData ? editUser(userForm.value) : inviteUser(userForm.value)">
        {{ (dialogData ? 'Global.Submit' : 'Global.SendInvite') | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
